import { isMobile } from "react-device-detect"
import { useGesture } from "react-use-gesture"
import PopupDialog from "../../components/PopupDialog"
import { SpecificationData } from "./Specification.data"
import {
  Holder,
  Title,
  Label,
  LightHolder,
  LightBgHolder,
  LightPH1,
  LightPH2,
  LightPH3,
  DarkHolder,
  DarkBgHolder,
  DarkPH1,
  DarkPH2,
  DarkPH3,
  Label1,
  Title1,
  BackButton,
  BackIcon,
  DialogContent,
  Image,
  TipHolder,
  Tip,
  DarkPH4,
  LightPH4,
  MarkText,
  PalText,
  ImageHolder
} from "./Specification.style.js"
import { useStore } from "../../state/store"

import Arrows from "../../components/Icons/navy_double_arrow_left.svg"

const pageVariants = {
  initial: {
    opacity: 0
  },
  in: {
    opacity: 1
  },
  out: {
    opacity: 0
  }
}

const pageTransition = {
  type: "spring",
  stiffness: 150,
  damping: 50,
  mass: 1.2
}

export default function Specification() {
  const openDlg = useStore(state => state.openDlg)
  const setOpenDlg = useStore(state => state.setOpenDlg)

  const index = useStore(state => state.index360)
  const setIndex = useStore(state => state.setIndex360)
  // const [index, setIndex] = useState(0)

  const handleBack = () => {
    if (openDlg) {
      setOpenDlg(false)
    }
  }
  const handlePHClick = idx => {
    setIndex(idx)
    setOpenDlg(true)
  }
  const handleDrag = state => {
    if (state.direction[1] === 1 && state.distance > (isMobile ? 10 : 50)) {
      handleBack()
    }
  }
  const bind = useGesture({ onDrag: state => handleDrag(state) }, {})
  return (
    <>
      <Holder
        initial="initial"
        animate="in"
        exit="out"
        variants={pageVariants}
        transition={pageTransition}
      >
        <LightHolder>
          <LightBgHolder>
            <Title color="#ffffff">West</Title>
            <Label color="#FFFFFF">
              Inspired by Postmark’s double postcode, two palettes have been created both influenced
              by the stylish elegance of the west, combined with nitty gritty undertones from the
              east.
            </Label>
          </LightBgHolder>
          <LightPH1
            onClick={() => {
              handlePHClick(0)
            }}
          />
          <LightPH2
            onClick={() => {
              handlePHClick(1)
            }}
          />
          <LightPH3
            onClick={() => {
              handlePHClick(2)
            }}
          />
          <LightPH4
            onClick={() => {
              handlePHClick(3)
            }}
          />
        </LightHolder>
        <DarkHolder>
          <DarkBgHolder>
            <Label1 color="#ffffff">
              Heritage is hugely important here, with the old sorting office, so we brought this
              forward in the little details; such as perforations in stamps, woven hessian details
              in the old postal sacks and the craftsmanship in pigeon holes, creating a subtle
              backdrop to our concept.
            </Label1>
            <Title1 color="#ffffff">East</Title1>
          </DarkBgHolder>
          <DarkPH1
            onClick={() => {
              handlePHClick(4)
            }}
          />
          <DarkPH2
            onClick={() => {
              handlePHClick(5)
            }}
          />
          <DarkPH3
            onClick={() => {
              handlePHClick(6)
            }}
          />
          <DarkPH4
            onClick={() => {
              handlePHClick(7)
            }}
          />
        </DarkHolder>
      </Holder>
      <PopupDialog show={openDlg}>
        <DialogContent {...bind()}>
          <ImageHolder>
            <Image img={SpecificationData[index].image}></Image>
            {SpecificationData[index].image2 && (
              <Image img={SpecificationData[index].image2}></Image>
            )}
          </ImageHolder>
          <TipHolder>
            <Tip>{SpecificationData[index].tips}</Tip>
          </TipHolder>
          <BackButton onClick={handleBack}>
            <BackIcon src={Arrows} />
          </BackButton>
          <MarkText>Specification</MarkText>
          <PalText>{SpecificationData[index].type}</PalText>
        </DialogContent>
      </PopupDialog>
    </>
  )
}
